// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface FileDownloadIconSignature {
  Element: SVGSVGElement;
}

export const FileDownloadIcon: TOC<FileDownloadIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.414 1H5C3.897 1 3 1.898 3 3V21C3 22.103 3.897 23 5 23H19C20.103 23 21 22.103 21 21V5.586L16.414 1ZM5 21V3H15V7H19L19.001 21H5ZM13 9V14H16L12 18L8 14H11V9H13Z"/>
</svg>
</template>;